module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAH1JREFUeNpi/P//P8ODBw9mMjAwnFVQUJjFgAaAcsZAqgOIwxjv37+vBGScAWJBIE5H1gBVuBsqF8YElLwHZLgC8XsgnglUkIZFIciQ1YwgZ2CRrADicnTb4IqxaGBAdxYTAwmACYepFeh+gCvG4plObJ4mKegYSYkUgAADAAVEV9LtIDS2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonials/video-close-btn.png
// module id = 502
// module chunks = 5